/**
 * Vista: Lista de Liberaciones de Tractor
 * Formato: AMX-PR-FR-03
 */

import produccionService from '../services/produccion.service.js';
import router from '../router/router.js';
import permisos from '../services/permissions.service.js';

export default {
  async render() {
    return `
      <div class="card">
        <div class="card-header" style="display: flex; justify-content: space-between; align-items: center;">
          <h2 class="card-title">Liberaciones de Tractor</h2>
          ${permisos.canCreate('liberaciones') ? `
            <button class="btn btn-primary" onclick="router.navigate('/produccion/liberaciones/nueva')">
              + Nueva Liberación
            </button>
          ` : ''}
        </div>

        <!-- Estadísticas rápidas -->
        <div id="statsContainer" class="stats-container" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 1rem; margin-bottom: 1.5rem;">
          <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div class="stat-value" id="statTotal" style="font-size: 1.5rem; font-weight: bold;">-</div>
            <div class="stat-label" style="color: var(--text-muted); font-size: 0.875rem;">Total Liberados</div>
          </div>
          <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div class="stat-value" id="statHoy" style="font-size: 1.5rem; font-weight: bold; color: var(--success);">-</div>
            <div class="stat-label" style="color: var(--text-muted); font-size: 0.875rem;">Hoy</div>
          </div>
          <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div class="stat-value" id="statSemana" style="font-size: 1.5rem; font-weight: bold; color: var(--primary);">-</div>
            <div class="stat-label" style="color: var(--text-muted); font-size: 0.875rem;">Esta Semana</div>
          </div>
          <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div class="stat-value" id="statMes" style="font-size: 1.5rem; font-weight: bold; color: var(--info);">-</div>
            <div class="stat-label" style="color: var(--text-muted); font-size: 0.875rem;">Este Mes</div>
          </div>
        </div>

        <!-- Filtros -->
        <div class="filters" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1rem; margin-bottom: 1.5rem;">
          <div class="form-group">
            <label class="form-label">Buscar</label>
            <input
              type="text"
              id="busqueda"
              class="form-input"
              placeholder="Num. Serie, Folio Certificado..."
            />
          </div>

          <div class="form-group">
            <label class="form-label">Modelo Certificado</label>
            <input
              type="text"
              id="modeloFilter"
              class="form-input"
              placeholder="Ej: TB504 III GEN"
            />
          </div>

          <div class="form-group">
            <label class="form-label">Desde</label>
            <input type="date" id="fechaDesde" class="form-input" />
          </div>

          <div class="form-group">
            <label class="form-label">Hasta</label>
            <input type="date" id="fechaHasta" class="form-input" />
          </div>

          <div class="form-group" style="display: flex; align-items: flex-end;">
            <button class="btn btn-secondary" onclick="window.liberacionesListView.limpiarFiltros()" style="width: 100%;">
              Limpiar Filtros
            </button>
          </div>
        </div>

        <!-- Tabla -->
        <div class="table-container">
          <table class="table">
            <thead>
              <tr>
                <th></th>
                <th>Num. Serie</th>
                <th class="tbl-hide-mobile">Fecha</th>
                <th class="tbl-hide-mobile">Modelo</th>
                <th class="tbl-hide-mobile">Folio Certificado</th>
                <th class="tbl-hide-mobile">Responsable</th>
                <th class="tbl-hide-mobile">Acciones</th>
              </tr>
            </thead>
            <tbody id="liberacionesTableBody">
              <tr>
                <td colspan="7" style="text-align: center; padding: 2rem;">
                  Cargando liberaciones...
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Paginación -->
        <div id="pagination" class="pagination" style="margin-top: 1rem;"></div>
      </div>
    `;
  },

  async afterRender() {
    if (!permisos.canView('liberaciones')) {
      if (permisos.primeraRuta) { router.navigate(permisos.primeraRuta); }
      else { document.getElementById('content').innerHTML = '<div style="display:flex;justify-content:center;align-items:center;height:60vh;"><div style="text-align:center;color:var(--primary);"><h2>Acceso denegado</h2><p>No tienes permisos para acceder a este módulo.</p></div></div>'; }
      return;
    }
    window.liberacionesListView = this;

    this.currentPage = 1;
    this.limit = 10;
    this.filters = {};

    // Event listeners
    document.getElementById('busqueda').addEventListener('input', (e) => {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.filters.search = e.target.value;
        this.currentPage = 1;
        this.cargarLiberaciones();
      }, 500);
    });

    document.getElementById('modeloFilter').addEventListener('input', (e) => {
      clearTimeout(this.modeloTimeout);
      this.modeloTimeout = setTimeout(() => {
        this.filters.modelo_certificado = e.target.value;
        this.currentPage = 1;
        this.cargarLiberaciones();
      }, 500);
    });

    document.getElementById('fechaDesde').addEventListener('change', (e) => {
      this.filters.fecha_desde = e.target.value;
      this.currentPage = 1;
      this.cargarLiberaciones();
    });

    document.getElementById('fechaHasta').addEventListener('change', (e) => {
      this.filters.fecha_hasta = e.target.value;
      this.currentPage = 1;
      this.cargarLiberaciones();
    });

    await this.cargarEstadisticas();
    await this.cargarLiberaciones();
  },

  async cargarEstadisticas() {
    try {
      const response = await produccionService.obtenerEstadisticasLiberaciones();
      const stats = response.data || response;

      document.getElementById('statTotal').textContent = stats.total || 0;
      document.getElementById('statHoy').textContent = stats.liberados_hoy || 0;
      document.getElementById('statSemana').textContent = stats.liberados_semana || 0;
      document.getElementById('statMes').textContent = stats.liberados_mes || 0;
    } catch (error) {
      console.error('Error al cargar estadísticas:', error);
    }
  },

  async cargarLiberaciones() {
    try {
      const params = {
        page: this.currentPage,
        limit: this.limit,
        ...this.filters
      };

      const response = await produccionService.listarLiberaciones(params);
      const liberaciones = response.data || response.liberaciones || response;
      const pagination = response.pagination || { page: 1, totalPages: 1, total: 0 };

      this.renderLiberaciones(Array.isArray(liberaciones) ? liberaciones : []);
      this.renderPaginacion(pagination);
    } catch (error) {
      toast.error('Error al cargar liberaciones');
      console.error('Error:', error);
      this.renderLiberaciones([]);
    }
  },

  renderLiberaciones(liberaciones) {
    const tbody = document.getElementById('liberacionesTableBody');

    if (!liberaciones || liberaciones.length === 0) {
      tbody.innerHTML = `
        <tr>
          <td colspan="7" style="text-align: center; padding: 2rem;">
            No se encontraron liberaciones
          </td>
        </tr>
      `;
      return;
    }

    tbody.innerHTML = liberaciones.map(l => {
      const fechaStr = l.fecha ? l.fecha.substring(0, 10).split('-').reverse().join('/') : '-';
      const accionesHtml = `
        ${l.completado
          ? (permisos.canView('liberaciones') ? `<button class="btn btn-sm btn-primary" onclick="window.liberacionesListView.verDetalle(${l.id})">Ver</button>` : '')
          : `${permisos.canEdit('liberaciones') ? `<button class="btn btn-sm btn-primary" onclick="window.liberacionesListView.verDetalle(${l.id})">Editar</button>` : ''}
             ${permisos.canDelete('liberaciones') ? `<button class="btn btn-sm btn-danger" onclick="window.liberacionesListView.eliminar(${l.id}, '${l.num_serie}')">Eliminar</button>` : ''}`
        }
      `;
      return `
      <tr>
        <td><button class="tbl-expand-btn" onclick="window.liberacionesListView.toggleRow(${l.id})">&#9654;</button></td>
        <td><strong>${l.num_serie}</strong></td>
        <td class="tbl-hide-mobile">${fechaStr}</td>
        <td class="tbl-hide-mobile">${l.modelo_certificado}</td>
        <td class="tbl-hide-mobile"><span class="badge badge-success">${l.folio_certificado}</span></td>
        <td class="tbl-hide-mobile">${l.responsable_linea || '-'}</td>
        <td class="tbl-hide-mobile">
          <div style="display: flex; gap: 0.5rem;">${accionesHtml}</div>
        </td>
      </tr>
      <tr class="tbl-detail-row" id="detail-lib-${l.id}">
        <td colspan="7" class="tbl-detail-cell">
          <dl class="tbl-detail-grid">
            <dt>Fecha</dt><dd>${fechaStr}</dd>
            <dt>Modelo</dt><dd>${l.modelo_certificado}</dd>
            <dt>Folio Cert.</dt><dd><span class="badge badge-success">${l.folio_certificado}</span></dd>
            <dt>Responsable</dt><dd>${l.responsable_linea || '-'}</dd>
          </dl>
          <div style="margin-top: var(--spacing-sm); display: flex; gap: var(--spacing-xs);">${accionesHtml}</div>
        </td>
      </tr>
    `}).join('');
  },

  renderPaginacion(pagination) {
    const container = document.getElementById('pagination');
    const { page, totalPages } = pagination;

    if (totalPages <= 1) {
      container.innerHTML = '';
      return;
    }

    let html = '<div style="display: flex; gap: 0.5rem; justify-content: center; align-items: center;">';

    html += `
      <button
        class="btn btn-sm btn-secondary"
        onclick="window.liberacionesListView.cambiarPagina(${page - 1})"
        ${page === 1 ? 'disabled' : ''}
      >
        Anterior
      </button>
    `;

    for (let i = 1; i <= totalPages; i++) {
      if (i === page) {
        html += `<button class="btn btn-sm btn-primary" disabled>${i}</button>`;
      } else if (i === 1 || i === totalPages || (i >= page - 2 && i <= page + 2)) {
        html += `
          <button
            class="btn btn-sm btn-secondary"
            onclick="window.liberacionesListView.cambiarPagina(${i})"
          >
            ${i}
          </button>
        `;
      } else if (i === page - 3 || i === page + 3) {
        html += '<span>...</span>';
      }
    }

    html += `
      <button
        class="btn btn-sm btn-secondary"
        onclick="window.liberacionesListView.cambiarPagina(${page + 1})"
        ${page === totalPages ? 'disabled' : ''}
      >
        Siguiente
      </button>
    `;

    html += '</div>';
    container.innerHTML = html;
  },

  toggleRow(id) {
    const detailRow = document.getElementById(`detail-lib-${id}`);
    const btn = detailRow?.previousElementSibling?.querySelector('.tbl-expand-btn');
    if (detailRow) {
      detailRow.classList.toggle('open');
      btn?.classList.toggle('open');
    }
  },

  cambiarPagina(page) {
    this.currentPage = page;
    this.cargarLiberaciones();
  },

  limpiarFiltros() {
    document.getElementById('busqueda').value = '';
    document.getElementById('modeloFilter').value = '';
    document.getElementById('fechaDesde').value = '';
    document.getElementById('fechaHasta').value = '';
    this.filters = {};
    this.currentPage = 1;
    this.cargarLiberaciones();
  },

  verDetalle(id) {
    router.navigate(`/produccion/liberaciones/${id}`);
  },

  eliminar(id, numSerie) {
    modal.confirm(
      'Confirmar eliminación',
      `¿Está seguro de eliminar la liberación del tractor <strong>${numSerie}</strong>? Esta acción no se puede deshacer.`,
      async () => {
        try {
          await produccionService.eliminarLiberacion(id);
          toast.success('Liberación eliminada');
          await this.cargarEstadisticas();
          await this.cargarLiberaciones();
        } catch (error) {
          toast.error(error.message || 'Error al eliminar liberación');
          console.error(error);
        }
      }
    );
  }
};
